import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";

import { TestAppState } from "../../app";
import { addApplicationsByRecordTypeCard } from "./cards/applications-by-record-type";
import { addCapabilityChartsCard } from "./cards/capability-charts";
import { addChannelsTableCard } from "./cards/channels-table";
import { addContractsCard } from "./cards/contracts";
import { addCountsCard } from "./cards/counts";
import { addCriticalityChartsCard } from "./cards/criticality-charts";
import { addDcSystemsCard } from "./cards/dc-systems";
import { addDistributionChannelChartsCard } from "./cards/distribution-channel-charts";
import { addLifeCycleChartsCard } from "./cards/life-cycle-charts";
import { addProcessStepChartsCard } from "./cards/process-step-charts";
import { addProgramDescriptionCard } from "./cards/program-description";
import { addProjectTeamCard } from "./cards/project-team";
import { addRecordSourceChartsCard } from "./cards/record-source-charts";
import { addTechnicalExposureChartsCard } from "./cards/technical-exposure-charts";
import { addTitleCard } from "./cards/title";

/**
 * Every card the dashboard is made of, **in the order they are added**.
 *
 * The order is the point of this array: the drag-and-drop layout places
 * cards by the sequence in which they reach the view, and
 * `dashboardComponentValues` is keyed by the component ids they register.
 * Keeping it here as data rather than as a run of calls inside the plugin is
 * what lets a spec assert it (#2222) — see
 * `dashboard.structure.spec.ts` — and what stops an import sorter from
 * silently reordering the page.
 *
 * 14 entries for up to 24 components: five of these add a pair or a small
 * group of cards that were hand-duplicated copies of a single block in the
 * original file (a bar chart plus its donut twin, or several small-number
 * cards registered back to back), and stay one function each for that
 * reason.
 *
 * Cards that never touch the app declare `(view)` alone; a narrower
 * parameter list is assignable to the wider type, so they need no unused
 * second parameter to sit in this array.
 */
export const DASHBOARD_CARDS: ((
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) => void)[] = [
  addTitleCard,
  addProgramDescriptionCard,
  addProjectTeamCard,
  addContractsCard,
  addDcSystemsCard,
  addCriticalityChartsCard,
  addCountsCard,
  addDistributionChannelChartsCard,
  addRecordSourceChartsCard,
  addProcessStepChartsCard,
  addCapabilityChartsCard,
  addTechnicalExposureChartsCard,
  addLifeCycleChartsCard,
  addApplicationsByRecordTypeCard,
  addChannelsTableCard,
];
